import { View } from "binder"
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { BooleanEditorViewModel } from "./booleanEditor-viewModel"

export class BooleanEditorView extends View<BooleanEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-12E3E9FB-8817-4BC2-A0BC-5CC0270E0A1F"
    }
    loadHtml(): string {
        let element = require('./booleanEditor.html').default;
        let style = require('./booleanEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    public set value(v: boolean) { this._value = getAsBoolean(v); } public get value(): boolean { return this._value;} private _value: boolean;

}
